var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAssign = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 0C3.73333 0 0 3.73333 0 8.33333C0 12.9333 3.73333 16.6667 8.33333 16.6667H12.5V15H8.33333C4.71667 15 1.66667 11.95 1.66667 8.33333C1.66667 4.71667 4.71667 1.66667 8.33333 1.66667C11.95 1.66667 15 4.71667 15 8.33333V9.525C15 10.1833 14.4083 10.8333 13.75 10.8333C13.0917 10.8333 12.5 10.1833 12.5 9.525V8.33333C12.5 6.03333 10.6333 4.16667 8.33333 4.16667C6.03333 4.16667 4.16667 6.03333 4.16667 8.33333C4.16667 10.6333 6.03333 12.5 8.33333 12.5C9.48333 12.5 10.5333 12.0333 11.2833 11.275C11.825 12.0167 12.7583 12.5 13.75 12.5C15.3917 12.5 16.6667 11.1667 16.6667 9.525V8.33333C16.6667 3.73333 12.9333 0 8.33333 0ZM8.33333 10.8333C6.95 10.8333 5.83333 9.71667 5.83333 8.33333C5.83333 6.95 6.95 5.83333 8.33333 5.83333C9.71667 5.83333 10.8333 6.95 10.8333 8.33333C10.8333 9.71667 9.71667 10.8333 8.33333 10.8333Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAssign, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/assign.c8572955.svg";
export { ForwardRef as ReactComponent };